import {
  FETCH_INTERNAL_NOTES_REQUEST,
  FETCH_INTERNAL_NOTES_SUCCESS,
  FETCH_INTERNAL_NOTES_FAILURE,
  EDIT_INTERNAL_NOTE_SUCCESS,
  DELETE_INTERNAL_NOTE,
} from './actions';
import { Map } from 'immutable';
import { ApiResponseHelper } from 'omni-common-ui';

export default function internalNotes(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_INTERNAL_NOTES_REQUEST:
      return state.set(action.sessionPlanId, ApiResponseHelper.create({ loading: true }));
    case FETCH_INTERNAL_NOTES_SUCCESS: {
      const data = ApiResponseHelper.create(action.payload);
      return state.set(action.sessionPlanId, data);
    }
    case FETCH_INTERNAL_NOTES_FAILURE:
      return state.set(action.sessionPlanId, ApiResponseHelper.create(action.error));
    case EDIT_INTERNAL_NOTE_SUCCESS: {
      const newInternalNotes = state.get(action.sessionPlanId);
      newInternalNotes.update('data', (data) => {
        if (action.index >= 0) {
          data.splice(action.index, 1);
        }
        data.splice(0, 0, action.internalNote);
      });
      return state.set(action.sessionPlanId, newInternalNotes);
    }
    case DELETE_INTERNAL_NOTE: {
      const newInternalNotes = state.get(action.sessionPlanId);
      newInternalNotes.update('data', (data) => {
        data.splice(action.index, 1);
      });
      return state.set(action.sessionPlanId, newInternalNotes);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/InternalNotes/reducer.js